import React, { Component } from 'react';
import logo from "../../images/GM-Cabs-card-logo.jpg";
import {
    Link, NavLink
} from 'react-router-dom';

class DefaulNavbar extends Component {
    render() {
        return (
            <nav className="navbar navbar-expand-sm bg-trans navbar-dark fixed-top" >
                <Link to="/" className="navbar-brand" href="#"><img src={logo} alt='' style={{ height: 70, width: 170 }} /></Link>
            </nav>
        );
    }
}

export default DefaulNavbar;


// WEBPACK FOOTER //
// ./src/components/navigation/defaultnavbar.jsx